import React from 'react';
import PropTypes from 'prop-types';
import { size } from 'lodash';
import ProductRecommendationsSkeleton from '../skeletonEffect/ProductRecommendationsSkeletonEffect';
import ProductRecommendationsTable from './ProductRecommendationsTable';

const ProductRecommendations = props => {
  const {
    labels,
    config,
    isLoading,
    productRecommendationAddToCart,
    productRecommendationTitleClick,
    shoppingCartError = {},
    productRecommendationData = [],
  } = props;

  if (size(productRecommendationData) === 0) return <></>;
  return (
    <div className="row">
      {isLoading ? (
        <ProductRecommendationsSkeleton />
      ) : (
        <ProductRecommendationsTable
          customClassName="col-md-12 col-xs-12 col-lg-12"
          productRecommendationData={productRecommendationData}
          productRecommendationAddToCart={productRecommendationAddToCart}
          shoppingCartError={shoppingCartError}
          labels={labels}
          config={config}
          productRecommendationTitleClick={productRecommendationTitleClick}
        />
      )}
    </div>
  );
};

ProductRecommendations.propTypes = {
  labels: PropTypes.objectOf([PropTypes.string]),
  config: PropTypes.objectOf([PropTypes.string]),
  isLoading: PropTypes.bool,
  productRecommendationData: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      addToCartDisabled: PropTypes.bool,
      purchasable: PropTypes.bool,
      isLoading: PropTypes.bool,
      custPrice: PropTypes.string,
      custValue: PropTypes.string,
      listPrice: PropTypes.string,
      listValue: PropTypes.string,
      currencyCode: PropTypes.string,
    })
  ),
  productRecommendationAddToCart: PropTypes.func,
  shoppingCartError: PropTypes.objectOf([PropTypes.string]),
  productRecommendationTitleClick: PropTypes.func,
};

ProductRecommendations.defaultProps = {
  labels: {},
  config: {},
  isLoading: false,
  productRecommendationData: [],
  shoppingCartError: {},
  productRecommendationAddToCart: () => {
    /* default productRecommendationAddToCart handler */
  },
  productRecommendationTitleClick: () => {
    /* default productRecommendationTitleClick handler */
  },
};

export default ProductRecommendations;
